// extracted by mini-css-extract-plugin
export var createdDate = "_l6-1";
export var divider = "_l6-2";
export var headerDivider = "_l6-3";
export var messagesCard = "_l6-0";
export var messagesContainer = "_l6-6";
export var messagesContainerWrapper = "_l6-4";
export var showLeftPanelButton = "_l6-8";
export var topButtons = "_l6-7";
export var withPadding = "_l6-5";